export default "/_next/static/d77db64a77742cd31f021161e4b32bef.png";